import { type Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";

// ---------------------- MSAL Configuration

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
  },
  cache: {
    // localStorage persists tokens across tabs and browser restarts,
    // avoiding re-authentication on every new tab or page refresh
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      logLevel:
        import.meta.env.VITE_CURRENT_MODE === "production"
          ? LogLevel.Error
          : LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error("[MSAL]", message);
        }
      },
    },
  },
};

// ---------------------- MSAL Instance

// Single global MSAL instance — shared across ApiService, route loaders, and components
export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL v4 requires explicit initialization before any API calls
export const msalReady = msalInstance.initialize();

// ---------------------- API Scope

// The custom scope defined in the Entra app registration for accessing the backend API
export const apiScope = import.meta.env.VITE_MSAL_API_SCOPE;

// Scopes array used by loginRedirect and acquireTokenSilent
export const loginRequest = {
  scopes: [apiScope],
};
